import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import { Button } from 'reactstrap';
import printBillingSummary from '../../../../utils/printers/BillingSummary';

const PrintBillingSummaryButton = ({ billings, user }) => {
  const rows = billings.get('rows') || [];
  const electronicTotal = billings.get('electronicTotal');

  const printTicket = () => {
    printBillingSummary({ rows, electronicTotal }, user);
  };

  return (
    <Button color="light" className="border" onClick={printTicket}>
      <i className="fa fa-print" /> Imprimir
    </Button>
  );
};

PrintBillingSummaryButton.propTypes = {
  billings: PropTypes.instanceOf(Immutable.Map).isRequired,
  user: PropTypes.shape({
    username: PropTypes.string,
    salesSessionUserId: PropTypes.number,
  }).isRequired,
};

const mapStateToProps = ({ authentication, AccountingUnit }) => ({
  user: authentication.get('user'),
  billings: AccountingUnit.Billing.getIn(['report', 'content']),
});

export default connect(mapStateToProps, null)(PrintBillingSummaryButton);
